import React from "react";
import { findAll } from "highlight-words-core";
import styled from "styled-components";

const styles = {
  destextstyle: {
    color: "white",
    fontFamily: "Lato",
    fontSize: "18px",
    paddingRight: 40,
    lineHeight: 40,
  },
  highlightStyle: {
    backgroundColor: "#ffdcc0",
    color: "white",
    fontFamily: "Lato",
    fontSize: "18px",
    borderRadius: 8,
  },
};

const TextLink = styled.a`
  cursor: pointer;
  font-style: normal;
  margin: 0 5px;
`;

export default function HighlightText(props) {
  if (
    props?.textToHighlight &&
    props?.searchWords &&
    props?.searchWords?.length > 0
  ) {
    const textToHighlight = props?.textToHighlight;
    const searchWords = props?.searchWords;
    const chunks =
      searchWords &&
      textToHighlight &&
      findAll({
        searchWords,
        textToHighlight,
      });
    return (
      <p style={props?.textstyle ? props?.textstyle : styles.destextstyle}>
        {chunks &&
          chunks.map((chunk, index) => {
            const text = textToHighlight.substr(
              chunk.start,
              chunk.end - chunk.start
            );
            return !chunk.highlight ? (
              text
            ) : (
              <TextLink
                key={index}
                style={
                  chunk.highlight && props?.highlightstyle
                    ? props?.highlightstyle
                    : styles.highlightStyle
                }
                onClick={() => props?.onHighlightClick(text)}
              >
                {text}
              </TextLink>
            );
          })}
      </p>
    );
  }
  return null;
}
